<!-- Begin Left Vertical Email List -->
<div>
  <div class="tw-grid tw-grid-cols-[auto_1fr] tw-items-center tw-p-3 tw-min-h-[69px]">
    <div>
      <span *ngIf="!actionItemsUserIsAuthUser" class="tw-font-bold">{{(user$ | async).fullName}}</span>
    </div>

    <div class="tw-text-right tw-grid tw-grid-cols-[auto_auto]">
      <mat-form-field class="tw-w-auto no-pad-wrapper" appearance="outline">
        <mat-select [placeholder]="'Type'" [class]="'no-arrow-transform'" [(value)]="selectedType" (selectionChange)="resetAndFetch()">
          <mat-select-trigger>{{selectedType | startcase}}</mat-select-trigger>
          <mat-option label="Unread" value="unread">
            Unread
          </mat-option>
          <mat-option value="read">
            Read
          </mat-option>
          <mat-option value="all">
            All
          </mat-option>
          <mat-option value="unknown">
            Unknown
            <div *ngIf="(unknownUnreadEmailThreads$ | async) as count" class="tw-ml-2 tw-text-sm tw-font-bold counter-pill {{count < 10 ? 'single-digit' : ''}}">
              {{count}}
            </div>
          </mat-option>
          <mat-option value="frontOfFunnel">
            Front of Funnel
          </mat-option>
          <mat-option value="backOfFunnel">
            Back of Funnel
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="tw-ml-2 tw-w-auto" appearance="outline">
        <mat-select [class]="'no-arrow-transform'" [(value)]="sortDirection" (selectionChange)="resetAndFetch()">
          <mat-option value="desc">Newest to oldest</mat-option>
          <mat-option value="asc">Oldest to newest</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <mat-list appDynamicScreenHeight class="!tw-p-0 tw-overflow-y-auto">
    <mat-card
      class="!tw-rounded-none mat-elevation-z0 tw-border-b {{ (activeThread$ | async)?.id === thread.id ? 'active' : '' }}"
      *ngFor="let thread of threads$ | async"
      (click)="fetchThread(thread.id)"
      (contextmenu)="onContextMenu($event, thread)">
      <div class="tw-grid tw-grid-cols-[24px_1fr]">

        <div class="tw-grid tw-items-center">
          <mat-icon class="tw-text-sm unread-messages-icon" *ngIf="jsonParse(thread.unreadMessageCount) > 0">fiber_manual_record</mat-icon>
        </div>

        <div class="tw-max-w-full tw-overflow-hidden">
          <div class="tw-absolute tw-text-right tw-right-6 tw-top-2 tw-pt-1 tw-grid tw-grid-flow-col">
            <mat-icon class="tw-mr-1 tw-text-gray-400" *ngIf="thread.containsAttachment">attachment</mat-icon>
            <mat-card-subtitle [ngClass]="{'tw-pt-2': thread.containsAttachment}">{{ thread.mostRecentMessageTime | timeago }}</mat-card-subtitle>
          </div>
          <mat-card-title class="mb-1 !tw-text-base tw-truncate tw-w-3/5"
            [ngClass]="{'!tw-font-bold': thread.unreadMessageCount > 0}">
            {{thread.borrowerName ? thread.borrowerName : thread.fromNames}}
            <span *ngIf="jsonParse(thread.unreadMessageCount) > 0">
              ({{thread.unreadMessageCount}})
            </span>
          </mat-card-title>
          <mat-card-subtitle class="mb-2 tw-truncate">{{thread.fromNames}}</mat-card-subtitle>
          <mat-card-subtitle class="mb-0 tw-font-bold !tw-text-base tw-truncate">{{thread.subject}}</mat-card-subtitle>
          <mat-card-subtitle class="mb-0 tw-pt-1 tw-truncate" [innerHTML]="thread.mostRecentPreview"></mat-card-subtitle>
        </div>
      </div>

    </mat-card>

    <div class="tw-flex tw-p-3 tw-items-center tw-justify-center">
      <mat-spinner diameter="24" *ngIf="( listLoading$ | async ) else nonLoadingState"></mat-spinner>

      <ng-template #nonLoadingState>
        <span *ngIf="!(threads$ | async).length else loadMoreButton">No threads found for this filter / user.</span>
        <ng-template #loadMoreButton>
          <button *ngIf="( showLoadMoreButton$ | async )" mat-stroked-button [color]="'primary'" (click)="loadMore()">Load More</button>
        </ng-template>
      </ng-template>

    </div>

  </mat-list>


  <div style="visibility: hidden; position: fixed"
       [style.left]="contextMenuPosition.x"
       [style.top]="contextMenuPosition.y"
       [matMenuTriggerFor]="contextMenu">
  </div>
  <mat-menu #contextMenu="matMenu">
    <ng-template matMenuContent let-userActionItem="userActionItem">
      <button mat-menu-item (click)="contextMenuMarkUnread()">Mark Unread</button>
    </ng-template>
  </mat-menu>

</div>
<!-- End Left Vertical Email List -->

<!-- Begin Email Content -->
<mat-divider [vertical]="true"></mat-divider>
<div appDynamicScreenHeight class="tw-grid tw-grid-flow-col tw-grid-cols-[55%_1px_1fr]">

  <div class="tw-grid tw-items-center" *ngIf="( borrowerOrThreadLoading$ | async ) else activeThread">
    <mat-spinner class="tw-m-auto" diameter="48"></mat-spinner>
  </div>

  <ng-template #activeThread>
    <div *ngIf="(activeThread$ | async) as thread else emptyState">

      <div *ngIf="selectedType === 'unknown'">
        <div class="tw-p-4 tw-grid tw-grid-flow-col">
          <div class="tw-pr-4">
            This message was sent from an unknown email. If you'd like to respond, you must first save this email address to an existing business record.
          </div>
          <div class="tw-w-96 tw-grid tw-grid-flow-col tw-gap-2 tw-items-center">
            <button
              mat-stroked-button
              [color]="'primary'"
              class="tw-mr-2"
              (click)="linkThreadToNewBorrower(thread)"
            >
              <mat-icon>add</mat-icon>
              New Merchant
            </button>
            <button
              mat-stroked-button
              [color]="'primary'"
              (click)="linkThreadToBorrower(thread)"
            >
              <mat-icon>add</mat-icon>
              Add to existing business
            </button>
          </div>
        </div>
        <mat-divider></mat-divider>
      </div>
      <div *ngIf="(validStatus$ | async) || selectedType === 'unknown'">
        <app-email-content
          [activeEmailThread]="thread"
          [joinedContacts]="(joinedContacts$ | async)"
          [borrower]="(borrower$ | async)"
          [lenderUser]="(lenderUser$ | async)"
          [loadingActiveEmailThread]="(threadLoading$ | async)"
          (emailCreate)="handleEmailCreate($event)"
        ></app-email-content>
      </div>
    </div>
  </ng-template>

  <ng-template #emptyState>
    <div></div>
  </ng-template>

  <mat-divider [vertical]="true"></mat-divider>
  <app-user-action-item-borrower-pane *ngIf="(activeThread$ | async) && selectedType !== 'unknown' else unknownBorrower"></app-user-action-item-borrower-pane>
  <ng-template #unknownBorrower>
    <div class="tw-p-4">
      <div class="tw-text-center tw-py-2 tw-bg-gray-100 tw-rounded-md">No related business detected</div>
    </div>
  </ng-template>
</div>
<!-- End Email Content -->
